import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=24f10b58&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"
import style0 from "./collapse.vue?vue&type=style&index=0&id=24f10b58&prod&scoped=true&lang=css"
import style1 from "./collapse.vue?vue&type=style&index=1&id=24f10b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f10b58",
  null
  
)

export default component.exports